import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '../SelectedShifts/bookButton.css';

const FilterButton = ({ onClick }) => (
  <FloatingActionButton
    style={{ zIndex: 1 }}
    className="filter-button"
    backgroundColor="rgba(0, 0, 0, 0.5)"
    mini
    onClick={onClick}>
    <FontAwesomeIcon icon={['fal', 'filter']} />
  </FloatingActionButton>
);

export default FilterButton;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/FilterButton.js